import React from 'react';
import './auth-pages-wrapper.scss';
import { isReplanApp } from '@utils/utils';
import { ReplanLoginIcon } from '@icons/icons/ReplanLoginIcon';
import { PlansimLoginIcon } from '@icons/icons/PlansimLoginIcon';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import classNames from 'classnames';

type Props = {
    children: React.ReactNode;
    showLogoColumn?: boolean;
};

export const AuthPagesWrapper: React.FC<Props> = ({ children, showLogoColumn = true }) => {
    const getLogoIconByOrigin = (url: string) => {
        return isReplanApp(url) ? <ReplanLoginIcon /> : <PlansimLoginIcon />;
    };

    const wrapperClasses = classNames('auth-pages-wrapper', !showLogoColumn && 'logo-col-hidden');

    return (
        <div className={wrapperClasses}>
            <div className="auth-pages-wrapper__header">
                <HeaderLogo active />
            </div>
            <div className="auth-pages-wrapper__form-col">
                <div className="auth-pages-wrapper__form">{children}</div>
            </div>
            {showLogoColumn ? (
                <div className="auth-pages-wrapper__logo-col">
                    <div className="auth-pages-wrapper__icon">
                        {getLogoIconByOrigin(window.location.origin)}
                    </div>
                </div>
            ) : null}
        </div>
    );
};
